import { put, select, takeLatest } from 'redux-saga/effects';
import {
  ADD_TAG_FILTER,
  REMOVE_TAG_FILTER,
  SET_TAG_FILTERS,
} from 'actionTypes';

import { getFilteredRecommendations } from 'actions';

function tagsAreEqual(tag1, tag2) {
  return tag1.id === tag2.id && tag1.schema === tag2.schema;
}

function* addTagFilterSaga({ tag }) {
  const filters = yield select(state => state.filters);

  if (!filters.tags.find(tag2 => tagsAreEqual(tag, tag2))) {
    yield put(
      getFilteredRecommendations({
        ...filters,
        tags: filters.tags.concat([tag]),
      })
    );
  }
}

function* removeTagFilterSaga({ tag }) {
  const filters = yield select(state => state.filters);
  let tags = filters.tags.filter(tag2 => !tagsAreEqual(tag, tag2));
  if (tags.length !== filters.tags.length) {
    yield put(getFilteredRecommendations({ ...filters, tags }));
  }
}

function* setTagFiltersSaga({ tags }) {
  const filters = yield select(state => state.filters);
  yield put(getFilteredRecommendations({ ...filters, tags }));
}

export default [
  takeLatest(ADD_TAG_FILTER, addTagFilterSaga),
  takeLatest(REMOVE_TAG_FILTER, removeTagFilterSaga),
  takeLatest(SET_TAG_FILTERS, setTagFiltersSaga),
];



// WEBPACK FOOTER //
// ./src/sagas/filteringSagas.js